import React from "react"

import style from "./style.module.scss"

import facebook from "../../images/facebook.svg"
import favicon from "../../images/favicon.png"

const Callback = () => {
  return (
    <footer className={style.callback}>
      <div className={style.phone}>
        <a href="tel:0800503580">0 800 503 580</a>
        <div>Дзвінки в межах України безкоштовні</div>
      </div>
      <div className={style.link_wrapper}>
        <a
          className={style.link}
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.facebook.com/tascombank"
        >
          <img width="16" height="16" src={facebook} alt="facebook" />
        </a>
        <a
          className={style.link}
          target="_blank"
          rel="noopener noreferrer"
          href="https://tascombank.ua"
        >
          <img
            width="16"
            height="16"
            src={favicon}
            alt="Логотип Таскомбанк"
          ></img>
        </a>
      </div>
    </footer>
  )
}

export default Callback
